<template>
    <div ref="windowDiv" class="staff w-[90%] h-[375px] cursor-pointer overflow-hidden max-w-[250px] m-[10px] rounded-[20px] border relative bg-white">
        <img :src="getImagePath(props.profile.photoName)" alt="" class="rounded-t-[15px] w-full h-[248px] bg-cover">
        <div class="p-[10px] w-full relative">
            <h1 class="text-sm font-bold text-center text-black h-[40px] flex"><span class="d-block m-auto">{{ props.profile.work }}</span></h1>
            <p class="text-gray-700 my-[10px] w-full text-center text-xs font-semibold">{{ props.profile.name }}</p>
            <div class="flex w-full relative justify-center z-40 items-center text-black flex-wrap">
                <a target="_blank" href="mailto:service.client@ironsecur.com" class="my-[5px] mx-[10px] ml-[0px] text-sm"><i class="fa-solid fa-envelope"></i></a>
                <a target="_blank" href="tel:+22943480141" class="my-[5px] mx-[10px] ml-[0px] text-sm"><i class="fa-solid fa-phone"></i></a>
                <a target="_blank" href="https://wa.me/+22943480141" class="my-[5px] mx-[10px] ml-[0px] text-sm"><i class="fa-brands fa-whatsapp"></i></a>
                <a target="_blank" :href="props.profile.linkdinProfile" class="my-[5px] mx-[10px] ml-[0px] text-sm"><i class="fa-brands fa-linkedin"></i></a>
            </div>
        </div>
        <div class="window absolute bottom-0 h-[375px] text-white font-semibold text-xs flex justify-center items-start w-full translate-y-[100%] p-[20px] ease-in-out duration-300 ">
            <div class="max-h-[260px] oa overflow-auto">
                <p class=" mb-[10px]">
                    {{ $t(props.profile.description_attribute) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import EmployeeProfile from '@/components/types/EmployeeProfile';

const props = defineProps<{
    profile: EmployeeProfile,
}>();

const windowDiv = ref<HTMLElement | null>(null);
const requireImages = require.context('@/assets/img/employee', false, /\.(png|jpe?g)$/)

const getImagePath = (fileName: string) => {
        try {
            return requireImages(`./${fileName}`)
        } catch (error) {
            return ''
        }
}



</script>


<style>
.open .ouvrir {
    display: none;
}

.open .fermer {
    display: block;
}

.window {
    backdrop-filter: blur(40px);
    background-color: rgba(0, 0, 0, 0.7);
}

.staff {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.staff:hover .window {
    transform: translateY(0%);
}

.staff:hover a i {
    color: white;
}

.text::-webkit-scrollbar, .oa::-webkit-scrollbar {
    width: 0%;
}
</style>